const gtmId = (type, id) => `GTM-CLICK-ITEM:${type}:${id}`

const gtmTypes = {
  heroChapterSelectorCard: "heroChapterSelectorCard",
  navMenuIcon: "navMenuIcon",
  navMenuTopicLink: "navMenuTopicLink",
  navMenuExpandedTopicLink: "navMenuExpandedTopicLink",
  navMenuChapterLink: "navMenuChapterLink",
  navBarPartnerLogo: "navBarPartnerLogo",
  explorerModuleCard: "explorerModuleCard",
  explorerChapterCard: "explorerChapterCard",
  explorerFeaturedCard: "explorerFeaturedCard",
  footerPrivacyLink: "footerPrivacyLink",
  hamburgerMenuIcon: "hamburgerMenuIcon",
  modalShareButton: "modalShareButton",
  shareMenuCopyLink: "shareMenuCopyLink",
  shareMenuEmailLink: "shareMenuEmailLink",
  shareMenuCloseMenu: "shareMenuCloseMenu",
  shareMenuPDFdownload: "shareMenuPDFdownload",
  chapterCarouselControlRight: "chapterCarouselControlRight",
  chapterCarouselControlLeft: "chapterCarouselControlLeft",
}

const getGTM = () => ({
  dataLayer: {
    page: window.document.location.pathname,
    event: "pageView",
  },
})

export { gtmId, gtmTypes, getGTM }
